export default __webpack_public_path__ + "static/media/readingSvg.2ef6ff99.svg";